<div class="w-full h-full px-5 py-5 space-y-5 text-center rounded  border border-slate-200"
  [ngClass]="{'bg-slate-100': dark(), 'bg-slate-50': !dark()}">
  @if (icon()) {
  <span class="fa-stack fa-2x">
    <i class="fa-solid fa-circle fa-stack-2x" [ngClass]="{'text-slate-50': dark(), 'text-slate-100': !dark()}"></i>
    <i class="{{icon()}} fa-stack-1x fa-inverse text-{{color()}}-600"></i>
  </span>
  }
  @if (name()) {
  <p class="text-green-600">{{name()}}</p>
  }
  @if (description()) {
  <p class="max-w-xl mx-auto">
    {{description()}}
  </p>
  }
  <ng-content></ng-content>
</div>